
export class ScanPassRequestDto {
  qrCodeString: string;
  targetId: string;
  force = false;
}
